import React from 'react';
import { Badge, Button, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { ApplicationIcons } from 'icons/ApplicationIcons';
import useMobile from 'services/Hooks/useMobile';
import { useApprovalNotification } from 'services/Data/NotificationService';
import { useSelector } from 'react-redux';

const AccountButton = () => {
  const { t } = useTranslation();
  const accountReducer = useSelector(state => state.AccountReducer);

  const { data: notification } = useApprovalNotification(accountReducer.isLoggedIn);
  const isMobile = useMobile();

  return (
    <React.Fragment>
      <Badge
        badgeContent={
          notification?.cartsNeedApproval || notification?.exteriorSignangesNeedApproval
            ? notification?.cartsNeedApproval + notification?.exteriorSignangesNeedApproval
            : null
        }
        color="error">
        <Button
          className={'toto'}
          style={{ boxShadow: 'none' }}
          variant="contained"
          endIcon={<ApplicationIcons.Users />}
          component={NavLink}
          to={'/dealer/profile'}>
          <Typography variant="h4">{isMobile ? '' : t('account')}</Typography>
        </Button>
      </Badge>
    </React.Fragment>
  );
};

export default AccountButton;
